import { Component, EventEmitter, Inject, OnInit, Output, AfterViewInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AddressService } from 'src/app/modules/address/service/address/address.service';
import { ErrorDialogService } from 'src/app/shared/errors/error-dialog.service';
import { ConfigService } from 'src/app/shared/services/config.service';
import { SnackBarService } from 'src/app/shared/snack-bar/services/snack-bar.service';
import {
  addressItemToRemoveInShipper,
  customMappingConfig,
  customMappingObjectConfig,
  exportCustomerInvoiceItemsToRemoveInShipmentMapping,
} from '../../../../custom-mapping/config/mapping-config';
import { basicSnackBarConfig } from 'src/app/utils/default-configs/configuration';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SpecificationService } from '../../../services/specification.service';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-add-edit-shipment-specification',
  templateUrl: './add-edit-shipment-specification.component.html',
  styleUrls: ['./add-edit-shipment-specification.component.scss'],
})
export class AddEditShipmentSpecificationComponent implements OnInit, AfterViewInit {
  @Output() dirtyEvent = new EventEmitter<boolean>();
  userExportedInvoice: boolean = false;
  selectedSpec;
  mappedFields: any = [];
  mappedFieldsForFile: any = [];
  unMappedFields = [];
  unMappedFieldsForFile: any = [];
  mandatoryFileds = [];
  shipperAddressData = [];
  mappingOptions = [];
  easyShipFieldData;
  standardShipdata;
  isDirty = false;
  isUseFromFile = false;
  shipmentMappingForm: FormGroup;
  specHeader = 'Create Shipment Specification';
  availableFieldsSubject = new BehaviorSubject(false);
  isFormDirty = true;

  lineItemList = [
    { name: 'lineItemNumber' },
    { name: 'lineItemDiscription' },
    { name: 'lineItemUnitPrice' },
    { name: 'lineItemUnitPriceCurrency' },
    { name: 'lineItemQuantity' },
    { name: 'lineItemQuantityUnitofMeasurement' },
    { name: 'lineItemExportCommodityCode' },
    { name: 'lineItemImportCommodityCode' },
    { name: 'lineItemExportReasonType' },
    { name: 'lineItemPartNumber' },
    { name: 'lineItemReference' },
    { name: 'lineItemManufactureCountry' },
    { name: 'lineItemNetWeight' },
    { name: 'lineItemGrossWeight' },
  ];
  lineItemLists = this.lineItemList.map(list => (list.name as any).padEnd(15)).join('\n');

  piecesList = [
    { name: 'pieceNumber' },
    { name: 'piecePackagingType' },
    { name: 'piecePackagingLength' },
    { name: 'piecePackageWidth' },
    { name: 'piecePackageHeight' },
    { name: 'piecePackageWeight' },
    { name: 'pieceReference' },
    { name: 'pieceId' },
    { name: 'pieceContentDescription' },
  ];
  pieceslists = this.piecesList.map(lists => (lists.name as any).padEnd(15)).join('\n');

  constructor(
    private fb: FormBuilder,
    private configService: ConfigService,
    private errorDialogService: ErrorDialogService,
    private addressService: AddressService,
    private snackBarService: SnackBarService,
    private dialogRef: MatDialogRef<AddEditShipmentSpecificationComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData,
    private specificationService: SpecificationService
  ) {}

  ngOnInit(): void {
    this.userExportedInvoice = sessionStorage.getItem('isCustomInvoice') === 'Custom';
    this.initializationformGroup();
    this.getShipperAddressData();
    // this.getMappingOptions();
    this.getMappedFields('EASYSHIP');
    this.getMappedFields('STANDARD');
    if (this.dialogData.action === 'update') {
      this.specHeader = 'Update Shipment Specification';
      this.availableFieldsSubject.subscribe(
        res => res && this.specSelectEvent({ value: this.dialogData.spec })
      );
    } else if (this.dialogData.action === 'upload') {
      this.availableFieldsSubject.subscribe(
        res =>
          res && this.executeOnRespose([this.dialogData.spec], this.dialogData.spec.file_format)
      );
    } else {
      this.specHeader = 'Create Shipment Specification';
    }
  }

  ngAfterViewInit() {
    this.isShipmentMappingUnChanged();
  }

  canDeactivate() {
    return this.isDirty;
  }

  isCheckedUseFromFile(event: MatCheckboxChange) {
    this.isUseFromFile = event.checked;
    if (this.isUseFromFile) {
      this.isFormDirty = false;
      this.mappedFields = this.mappedFieldsForFile;
      this.unMappedFields = this.unMappedFieldsForFile;
    }
    if (this.userExportedInvoice && this.shipmentMappingForm.value.file_format === 'EASYSHIP') {
      this.unMappedFields = this.unMappedFields.filter(item => item !== 'lineItems');
      this.mappedFields = this.mappedFields.filter(item => item !== 'lineItems');
    } else {
      this.isFormDirty = true;
    }
    this.shipmentMappingForm.patchValue({ use_shipper_id: '' });
  }

  isShipmentMappingUnChanged() {
    setTimeout(() => {
      setTimeout(
        function () {
          this.shipmentMappingForm.valueChanges.subscribe(() => {
            this.isDirty = true;
            this.dirtyEvent.emit(this.isDirty);
          });
        }.bind(this),
        0
      );
    }, 1000);
  }

  initializationformGroup() {
    this.shipmentMappingForm = this.fb.group({
      specifications_id: ['', Validators.required],
      file_format: ['', Validators.required],
      delimiter: ['', Validators.required],
      acceptTerms: ['True'],
      use_for_automated_upload: [false],
      use_shipper_id: '',
      headers: [false],
      useFromFile: [false],
      abortOnErrors: [false, Validators.required],
    });
  }

  easyship() {
    this.mapOptionData(this.easyShipFieldData);
  }

  standard() {
    this.mapOptionData(this.standardShipdata);
  }

  specSelectEvent(spec) {
    this.shipmentMappingForm.reset();
    this.getSelectMappingOption(spec.value.specifications_id, spec.value.file_format);
  }

  changeAddressValue(address) {
    if (!address.value) {
      this.isFormDirty = true;
    } else {
      this.isFormDirty = false;
    }
    this.mappedFields = customMappingConfig(this.mappedFields, addressItemToRemoveInShipper);
    this.unMappedFields = customMappingConfig(this.unMappedFields, addressItemToRemoveInShipper);
    this.shipmentMappingForm.controls.use_shipper_id.setValue(address.value);
  }

  getSelectMappingOption(specId, specFormat) {
    this.shipmentMappingForm.reset();
    this.configService
      .getMappingFromOption('customer_mapping_specifications', specId)
      .subscribe(res => {
        this.executeOnRespose(res, specFormat);
      });
  }

  executeOnRespose(res, specFormat) {
    this.isUseFromFile = !res[0]?.use_shipper_id;
    if (res[0]?.use_shipper_id) {
      this.isFormDirty = false;
    } else if (this.isUseFromFile) {
      this.isFormDirty = false;
    } else {
      this.isFormDirty = true;
    }
    this.shipmentMappingForm.patchValue({ useFromFile: this.isUseFromFile });
    this.mappedFields = [];
    this.mappedFieldsForFile = this.mappedFields = res[0].data.map(function (item) {
      return item === 'TBA' ? 'Blank' : item;
    });
    if (this.userExportedInvoice) {
      let userExportedMappedFields = [];
      userExportedMappedFields = customMappingConfig(
        res[0].data,
        exportCustomerInvoiceItemsToRemoveInShipmentMapping
      );
      this.mappedFieldsForFile = this.mappedFields = userExportedMappedFields?.map(function (item) {
        return item === 'TBA' ? 'Blank' : item;
      });
      //TODO : In-case mapped issue if customer is enabled invoice
      this.unMappedFieldsForFile = this.unMappedFields = customMappingConfig(
        this.unMappedFields,
        exportCustomerInvoiceItemsToRemoveInShipmentMapping
      );
    }
    if (specFormat === 'EASYSHIP') {
      const allEasyshipFields = this.getAllShipFields(this.easyShipFieldData);
      this.unMappedFieldsForFile = this.unMappedFields = this.filterTwoArrayNotIncluded(
        allEasyshipFields,
        this.mappedFields
      );
      if (this.userExportedInvoice) {
        this.unMappedFields = this.unMappedFields.filter(item => item !== 'lineItems');
      }
      this.mandatoryFileds = this.getMondatoryFields(this.easyShipFieldData);
      this.assignFormFieldsData(res[0]);
    } else {
      const allStandardshipFields = this.getAllShipFields(this.standardShipdata);
      this.unMappedFieldsForFile = this.unMappedFields = this.filterTwoArrayNotIncluded(
        allStandardshipFields,
        this.mappedFields
      );
      this.mandatoryFileds = this.getMondatoryFields(this.standardShipdata);
      this.assignFormFieldsData(res[0]);
    }
  }

  assignFormFieldsData(data) {
    this.shipmentMappingForm.patchValue(data);
  }

  filterTwoArrayNotIncluded(arr1, arr2) {
    const unMappedWithBlank = ['Blank'];

    const arrayUnmapped = arr1.filter(x => !arr2.includes(x));

    return unMappedWithBlank.concat(arrayUnmapped);
  }

  getAllShipFields(mappingData) {
    const shipFields = [];

    for (const mappingObj of mappingData) {
      const fieldName = mappingObj.field_name;
      shipFields.push(fieldName);
    }

    return shipFields;
  }

  getMappedFields(fileformat) {
    const id = 'field_specifications';
    this.configService.getMappingFields(id, fileformat).subscribe(response => {
      this.userExportedInvoice
        ? this.getCustomInvoiceAvailableFields(fileformat, response)
        : this.getDefaultAvailableFields(fileformat, response);
      if (this.easyShipFieldData?.length && this.standardShipdata?.length) {
        this.availableFieldsSubject.next(true);
      }
    });
  }

  getCustomInvoiceAvailableFields(fileFormat, response) {
    return fileFormat === 'EASYSHIP'
      ? (this.easyShipFieldData = customMappingObjectConfig(response[0].data))
      : (this.standardShipdata = customMappingObjectConfig(response[0].data));
  }

  getDefaultAvailableFields(fileFormat, response) {
    return fileFormat === 'EASYSHIP'
      ? (this.easyShipFieldData = response[0].data)
      : (this.standardShipdata = response[0].data);
  }

  mapOptionData(mappingData) {
    this.mappedFields = [];
    this.unMappedFields = ['Blank'];
    this.mandatoryFileds = [];
    for (const mappingObj of mappingData) {
      const fieldName = mappingObj.field_name;
      if (mappingObj.required === 'M') {
        this.mappedFields.push(fieldName);
        this.mappedFieldsForFile = this.mappedFields;
        this.mandatoryFileds.push(fieldName);
      } else {
        this.unMappedFieldsForFile = this.unMappedFields;
        this.unMappedFields.push(fieldName);
      }
    }
    this.checkExportedInvoiceEnabled();
  }

  checkExportedInvoiceEnabled() {
    this.userExportedInvoice = sessionStorage.getItem('isCustomInvoice') === 'Custom';
    //TODO : If the customer have export invoice enabled
    if (this.userExportedInvoice) {
      this.mappedFields = customMappingConfig(
        this.mappedFields,
        exportCustomerInvoiceItemsToRemoveInShipmentMapping
      );
      this.unMappedFields = customMappingConfig(
        this.unMappedFields,
        exportCustomerInvoiceItemsToRemoveInShipmentMapping
      );
    }
  }

  getMondatoryFields(mappingData) {
    this.mandatoryFileds = [];
    for (const mappingObj of mappingData) {
      const fieldName = mappingObj.field_name;
      if (mappingObj.required === 'M') {
        this.mandatoryFileds.push(fieldName);
      }
    }
    return this.mandatoryFileds;
  }

  drop(event: CdkDragDrop<string[]>) {
    this.shipmentMappingForm.markAsDirty();
    this.isDirty = true;
    this.dirtyEvent.emit(this.isDirty);
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      if (this.isFieldMondatory(event.previousContainer.data[event.previousIndex])) {
        return;
      } else {
        const previousIndexValue = event.previousContainer.data[event.previousIndex];
        if (previousIndexValue === 'Blank' && event.previousContainer.id === 'cdk1') {
          this.mappedFields.splice(event.currentIndex, 0, previousIndexValue);
          return;
        }
        if (previousIndexValue === 'Blank' && event.previousContainer.id === 'cdk2') {
          this.mappedFields.splice(event.previousIndex, 1);
          return;
        }

        transferArrayItem(
          event.previousContainer.data,
          event.container.data,
          event.previousIndex,
          event.currentIndex
        );
      }
    }
  }

  isFieldMondatory(field) {
    return this.mandatoryFileds.includes(field);
  }

  getShipperAddressData() {
    const requestData = {
      query: {
        address_type: ['SHIPPER'],
      },
    };
    this.addressService.getAddressList(requestData).subscribe(
      res => {
        for (const addressObj of res.data) {
          const AddressString = '';
          this.shipperAddressData.push({
            address_id: addressObj.address_id,
            shipperNickName: addressObj.shipperNickName,
          });
        }
      }
      // err => {
      //   console.log('error' + err);
      // }
    );
  }

  saveShipmentConfigMapping() {
    if (!this.shipmentMappingForm.valid) {
      this.errorDialogService.openDialog('alert.enterAllMandatory', false);
      return;
    }

    if (
      !this.shipmentMappingForm.value.useFromFile &&
      this.shipmentMappingForm.value.use_shipper_id.length < 1
    ) {
      this.errorDialogService.openDialog('alert.enterAllMandatory', false);
      return;
    }

    if (this.shipmentMappingForm.value.use_for_automated_upload === '') {
      this.shipmentMappingForm.value.use_for_automated_upload = false;
    }

    if (this.shipmentMappingForm.value.abortOnErrors === '') {
      this.shipmentMappingForm.value.abortOnErrors = false;
    }
    const dataFields = this.mappedFields.map(function (item) {
      return item === 'Blank' ? 'TBA' : item;
    });

    const options = {
      config_id: 'customer_mapping_specifications',
      specifications_id: this.shipmentMappingForm.value.specifications_id,
      headers: Boolean(this.shipmentMappingForm.value.headers),
      data: this.userExportedInvoice
        ? customMappingConfig(dataFields, exportCustomerInvoiceItemsToRemoveInShipmentMapping)
        : dataFields,
      file_format: this.shipmentMappingForm.value.file_format,
      use_for_automated_upload: Boolean(this.shipmentMappingForm.value.use_for_automated_upload),
      delimiter: this.shipmentMappingForm.value.delimiter,
      abortOnErrors: Boolean(this.shipmentMappingForm.value.abortOnErrors),
      use_shipper_id: this.shipmentMappingForm.value.use_shipper_id,
    };

    this.configService.saveMappingOption(options).subscribe(() => {
      this.snackBarService.createSnackBar(
        basicSnackBarConfig.mappingShipmentSpecificationSave?.message,
        basicSnackBarConfig.mappingShipmentSpecificationSave?.horizontalPosition,
        basicSnackBarConfig.mappingShipmentSpecificationSave?.verticalPosition,
        basicSnackBarConfig.mappingShipmentSpecificationSave?.duration
      );
      this.getMappingOptions();
      this.specificationService.onSpecUpdateAndCreation.next(false);
      this.dialogRef.close({ value: true });
    });
  }

  getMappingOptions() {
    const id = 'customer_mapping_specifications';
    this.configService.getListOfMappings(id).subscribe(data => {
      const spec = this.selectedSpec;
      this.mappingOptions = data[0];
      this.selectedSpec = spec;
      this.isDirty = false;
      this.dirtyEvent.emit(this.isDirty);
    });
  }
}
